import { Component, Input, OnInit, NgModule, ChangeDetectionStrategy } from '@angular/core';

import { PageTitleService } from './../../../../services/ui/page-title.service';

@Component({
    selector: 'cmn-page-title',
    templateUrl: 'cmn-page-title.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CmnPageTitleComponent implements OnInit {
    pageTitle: string = "";
    constructor(public pageTitleService: PageTitleService) {
        
    }
    
    ngOnInit() {
         
    }
}